
  export const ONLINEACCESSS_RECEIVED = "ONLINEACCESSS_RECEIVED";
  export const SET_ONLINEACCESS = "SET_ONLINEACCESS";
  export const CREATE_ONLINEACCESS = "CREATE_ONLINEACCESS";
  export const SET_PROPERTY_ONLINEACCESS = "SET_PROPERTY_ONLINEACCESS";
  